import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WaitLoadingComponent } from './waitLoading.component';
import { TranslateModule } from '@ngx-translate/core';
import { WaitComponent } from './wait.component';

@NgModule({
  declarations: [WaitLoadingComponent, WaitComponent],
  imports: [CommonModule, TranslateModule],
  exports: [WaitLoadingComponent, WaitComponent]
})
export class WaitLoadingModule { }
